import * as types from "./types";
import {
    getVehicleListAxios,
    deleteVehicleAxios,
    postVehicleAxios,
    putVehicleAxios,
    getVehicleByIDAxios
} from "./services";

export async function getVehicleListAction({ commit }) {
    commit(types.LOADING_DISTRIBUTION_VEHICLE, true);
    try {
        const { data } = await getVehicleListAxios();
        commit(types.GET_DISTRIBUTION_VEHICLE_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DISTRIBUTION_VEHICLE, false);
    }
}

export async function removeVehicleAction({ commit }, payload) {
    commit(types.LOADING_DISTRIBUTION_VEHICLE, true);
    try {
        await deleteVehicleAxios(payload);
        commit(types.REMOVE_DISTRIBUTION_VEHICLE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DISTRIBUTION_VEHICLE, false);
    }
}

export async function addVehicleAction({ commit }, payload) {
    commit(types.LOADING_DISTRIBUTION_VEHICLE, true);
    try {
        await postVehicleAxios(payload);
        commit(types.ADD_DISTRIBUTION_VEHICLE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DISTRIBUTION_VEHICLE, false);
    }
}

export async function updateVehicleAction({ commit }, payload) {
    commit(types.LOADING_DISTRIBUTION_VEHICLE, true);
    try {
        await putVehicleAxios(payload);
        commit(types.UPDATE_DISTRIBUTION_VEHICLE, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DISTRIBUTION_VEHICLE, false);
    }
}

export async function getVehicleByIDAction({commit}, payload) {
    commit(types.LOADING_DISTRIBUTION_VEHICLE, true);
    try {
        
        const {data} = await getVehicleByIDAxios(payload);
        commit(types.GET_DISTRIBUTION_VEHICLEBYID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DISTRIBUTION_VEHICLE, false);
    }
   
}